// extracted by mini-css-extract-plugin
module.exports = {"container":"week-day-module--container--22qBA","day":"week-day-module--day--34fkh","sol":"week-day-module--sol--18TTq"};